module.exports = __webpack_public_path__ + "media/images/logo-desk-nl-5403c7cefa0105d2a2a9500782ab2694.svg";